module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/132acc314440b901152ad805d8911aaf.png";